import { State } from '../../../store/state';

export const priceSuggestionSelector = (state: State) => state.priceSuggestion;
export const priceSuggestionLoadingSelector = (state: State) => state.priceSuggestion.loading;
export const suggestedPriceSelector = (state: State) => state.priceSuggestion.suggestedPrice;
export const priceSuggestionErrorSelector = (state: State) => state.priceSuggestion.error; 